import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements AfterViewInit {
  @Input() lang!: string;
  faFacebook = faFacebook;
  faWhatsapp = faWhatsapp;
  faLinkedin = faLinkedin;
  logoPath!: string;
  whiteLogoPath!: string;
  languages: any = [];
  selectedLanguage: any;
  headerData: any;
  tabs: any = [];

  userInfo: any;

  @ViewChild('menu_icon') menu!: ElementRef;
  @ViewChild('close_icon') close!: ElementRef;
  @ViewChild('header') header!: ElementRef;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private fetchDataService: FetchDataService,
    private userInfoService: UserInfoService
  ) {
    this.userInfo = this.userInfoService.getUserInfo();
    this.logoPath =
      '../../../assets/' + environment.projectName + '/media/header/logo.png';

    this.whiteLogoPath = '';
    // '../../../assets/' +
    // environment.projectName +
    // '/media/header/whiteLogo.png';
    this.fetchDataService.getJSONheader().subscribe({
      next: (data: any) => {
        this.tabs = data?.tabs;
        if (this.userInfo.accessToken && this.userInfo.userId) {
          this.tabs = this.tabs.filter(
            (tab: any) => tab.name !== 'header_login'
          );
        } else {
          this.tabs = this.tabs.filter(
            (tab: any) => tab.name !== 'header_profile'
          );
        }

        this.languages = data?.languages;

        this.selectLanguage(this.lang);
      },
      error: (err) => {
        console.error('Error fetching services:', err);
      },
    });
  }

  ngAfterViewInit() {
    if (this.menu && this.menu.nativeElement) {
      this.menu.nativeElement.addEventListener('click', () => {
        this.header.nativeElement.classList.remove('d-none');
      });
    }
  }

  selectLanguage(lang: any) {
    this.selectedLanguage =
      this.languages && this.languages.find((item: any) => item.value === lang);
    this.translate.setDefaultLang(lang);
    this.closeNavbar();
  }

closeNavbar() {
  if (this.header && this.header.nativeElement) {
    this.header.nativeElement.classList.remove('open');
  }
}


  getNewURL(lang: string): string {
    const url = this.router.url;
    return url.replace(/\/[a-z]{2}(\/|$)/, `/${lang}$1`);
  }
  openedTab: any = null;

  isActive(tab: any): boolean {
    return location.pathname.includes(tab.route);
  }

  closeMobileMenu(): void {
  const el = document.getElementById('toggle') as HTMLInputElement | null;
  if (el) {
    el.checked = false;
  }
}


isLangMenuOpenMobile = false;
isLangMenuOpenDesktop = false;



toggleTab(tab: any) {
  this.openedTab = this.openedTab === tab ? null : tab;
}

toggleLanguageMenu(type: 'mobile' | 'desktop', event?: Event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation(); // stops clicks from bubbling and closing immediately
  }
  if (type === 'mobile') {
    this.isLangMenuOpenMobile = !this.isLangMenuOpenMobile;
  } else {
    this.isLangMenuOpenDesktop = !this.isLangMenuOpenDesktop;
  }
}

onLanguageSelect(lang: string, event: Event) {
  event.preventDefault();
  event.stopPropagation();
  this.selectLanguage(lang);
  this.router.navigateByUrl(this.getNewURL(lang));
  this.isLangMenuOpenDesktop = false;
  this.isLangMenuOpenMobile = false;
}


}
